import React, { useEffect } from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQuery } from 'react-query';
import { getTeams } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import TeamsTable from "components/common/participants/TeamsTable";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import Selector_Event from "components/common/selectors/SelectorEvent";
import { Stack } from "react-bootstrap";
import SelectorNoc from "components/common/selectors/selector-noc";
import PageHeader from 'components/common/PageHeader';
import Label from 'components/general/Label';
import useViewport from "components/general/useViewPort";


const Teams = () => {
    const [dataState, setDataState] = React.useState([]);
    const { mirs_competition, mirs_language, mirs_discipline, mirs_event, mirs_noc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['teams', mirs_competition, mirs_language],
            queryFn: getTeams,
            refetchInterval: 0,
            //staleTime: 5000,
            //refetchIntervalInBackground: true
        });



    useEffect(() => {
        let filterData = data?.teams

        if (mirs_discipline && mirs_discipline !== "all-disc") {
            filterData = filterData?.filter(item => item?.discipline?.code === mirs_discipline)
        }
        if (mirs_noc && mirs_noc !== "all-noc") {
            filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        }
        if (mirs_event && mirs_event !== "all-event") {
            filterData = filterData?.filter(item => item?.registeredEvents.find(e => e?.code === mirs_event));
        }

        setDataState(filterData);
    }, [data, mirs_noc, mirs_discipline, mirs_event]);



    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.teams) { return <NotAvailable /> }



    const handleOnChange = event => {
        const { name, value } = event.target;

        let filterData = data?.teams
        if (mirs_discipline && mirs_discipline !== "all-disc") {
            filterData = filterData?.filter(item => item?.discipline?.code === mirs_discipline)
        }
        if (mirs_noc && mirs_noc !== "all-noc") {
            filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        }
        if (mirs_event && mirs_event !== "all-event") {
            filterData = filterData?.filter(item => item?.registeredEvents.find(e => e?.code === mirs_event));
        }

        filterData = filterData?.filter(item => item?.name?.toLowerCase().includes(value.toLowerCase()));
        setDataState(filterData)
    };

    return (<>
        <PageHeader title={<Label data="LabelTeams" />} />
        <div className='mirs-page-container'>
            <Stack direction={isMobile ? 'vertical' : 'horizontal'}>
                <SelectorDiscipline display_type="combo" page="teams" />
                <SelectorNoc display_type="combo" page="teams" />
                <Selector_Event display_type="combo" page="teams" />
                <div className="d-flex">
                    <input type="text" className="form-control" name="Team" id="Team" placeholder="Team" onChange={handleOnChange} />
                </div>
            </Stack>
            <div>
                {dataState && <TeamsTable data={dataState} key={`teams`} />}
            </div>
        </div>
    </>
    )
};

export default Teams

